import { useContext } from 'react'

import { OverviewContext } from '../providers/OverviewProvider'

export const useOverviewContext = () => {
  const overviewContext = useContext(OverviewContext)

  if (overviewContext === undefined) {
    throw new Error('overviewContext must be used within a OverviewProvider')
  }

  return overviewContext
}
